import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'


// if (error.toString() == 'Error: Network Error') {
// 	window.location.href = 'http://ssa.jd.com/sso/login?ReturnUrl=' + encodeURIComponent(window.location.href)
// 	return Promise.reject(error.response);
// }

/**
 * 响应拦截器, 将网络异常的情况也做resolve处理
 */
axios.interceptors.response.use(response => {
	return response;
}, error => {
	let response;
	if(error.response){
		response = error.response;
	}else if(error.request){
		response = {status : 'NO_RESPONSE_RETURN', statusText : 'no response return', config : error.config};
	}else{
		response = {status : 'REQUEST_NOT_SEND', statusText : 'request not send', config : error.config};
	}
	return Promise.resolve(response);
});

/**
 * 处理http状态, 200之外的响应, 重写数据内容, code值为-99999
 * @param response
 * @returns {*}
 */
function handleHttpStatus(response) {
	if(response.status === 200){
		return response.data;
	}
    if(response.status==401) {
        window.location.href = 'http://ssa.jd.com/sso/login?ReturnUrl=' + encodeURIComponent(window.location.href);
        return;
    }
	let message = 'request url: "' + response.config.url + '", http status: ' + response.status + ', status text: "' + response.statusText + '"';
	message += response.data ? (', response data: "' + response.data + '"') : ''
	return {
		code : -99999,
		message : message
	};
}

/**
 * 处理系统异常code状态
 * @param data
 * @returns {*}
 */
function handleErrorCode(data) {
	if(data.code < 0){
		console.log("系统错误, code: [" + data.code + "], message: [" + data.message +"]");
	}
	return data;
}



let http = {

    postFile(url, data) {
        let formData = new FormData();
        for (var key in data) {
            formData.append(key, data[key]);
        }
        return axios({
            method: 'post',
            url: url,
            data: formData,
            timeout: 2100000,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'multipart/form-data'
            }
        }).then(handleHttpStatus).then(handleErrorCode);
    },

    postJSON(url, data) {
        return axios({
            method: 'post',
            url: url,
            data: JSON.stringify(data),
            timeout: 2100000,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json;charset=UTF-8'
            }
        }).then(handleHttpStatus).then(handleErrorCode);
    },

	post(url, data) {
		return axios({
			method: 'post',
			url: url,
			data: qs.stringify(data),
			timeout: 2100000,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			}
		}).then(handleHttpStatus).then(handleErrorCode);
	},


	get(url, data) {
		return axios({
			method: 'get',
			url: url,
			params: data,
			timeout: 2100000,
			headers: {
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(handleHttpStatus).then(handleErrorCode);
	},

    delete(url, data) {
        return axios({
            method: 'delete',
            url: url,
            params:data,
            timeout: 2100000,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }).then(handleHttpStatus).then(handleErrorCode);
    },
};
Vue.prototype.$http = http;

export default http;
